import router from '../../../router'
import { SortedTable, SortLink } from 'vue-sorted-table'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import {Booking} from "@/services/booking.service";
import TabBar from '../../../components/tab-bar/TabBar'
import InputText from '../../../components/input-text/InputText'
import InputButton from '../../../components/input-button/InputButton'
import InputDropdownFilter from '../../../components/input-dropdown-filter/InputDropdownFilter'
import OpeningHoursSelector from  '../../../components/opening-hours-selector/OpeningHoursSelector'
import OpeningHoursViolations from '../../../components/opening-hours-violations/OpeningHoursViolations'
import Loader from '../../../components/loader/Loader'
import SettingsHeader from '../../../components/settings-header/SettingsHeader'
import { LocationService, Location, OpeningHours } from '../../../services/location.service'
import { GroupService, GroupDropdown, Group } from '../../../services/group.service'
import {Constants} from "@/constants";
import { ScreenLoader } from '../../../utils/loading.util'
import {EntityService} from "@/services/entity.service";
import moment from 'moment'
import InputCheckbox from "@/components/input-checkbox/InputCheckbox";

export default {
    name: 'Location',
    components: {
        NavigationBar,
        TabBar,
        InputText,
        InputDropdownFilter,
        InputCheckbox,
        OpeningHoursSelector,
        OpeningHoursViolations,
        InputButton,
        Loader,
        SettingsHeader,
        SortedTable,
        SortLink,
    },

    data() {
        return {
            location: new Location(),
            groups: [],
            dropdownGroups: [],
            screenLoader: new ScreenLoader(),
            openingHoursInput: new OpeningHours(),
            openingHours: {},
            violations: Array,
            showViolations: false,
            exceptionOnly: true,
            alertOnGateUpdate: false,
            bookingsPrivateForAgent: false
        }
    },

    mounted() {
        this.getMetaData()
    },

    computed: {
      registrationLink () {
          return `${window.location.protocol}//${window.location.host}?location=${this?.location?.id}&name=${this.location?.name}`
      },
    },

    methods: {
        doClear(reference) {
            this.location[reference] = ''
        },

        doSave: async function() {
            this.openingHours = LocationService.convertOpeningHours(this.openingHoursInput)
            this.location.openingHours = this.openingHours
            let violations = await LocationService.findViolatingBookings(this.location, this.location.openingHours)
            if (violations.length === 0) {
                // notify the user that continueing will also override all entities
                const caution = this.exceptionOnly
                    ? "Caution, this action will override the exceptions for all entities!"
                    : "Caution, this action will override the opening hours and exceptions for all entities!"
                if (confirm(caution)) {
                    //update locations
                    await this.updateLocation(this.location).then(() => {
                        // update entities
                        this.updateEntities(this.exceptionOnly)
                    })
                }
            } else {
                this.showViolations = !this.showViolations
                this.violations = violations
            }
        },


        doCancel() {
            router.push(`/settings/locations`)
        },

        toggleAutoApproveBooking() {
            this.location.autoApproveBooking = !this.location.autoApproveBooking
        },

        getMetaData: async function() {
            this.screenLoader.start(['locations'])

            try {
                const groups = await GroupService.getGroups()
                this.handleMetaDataResponse(groups)
            } catch (error) {
                this.screenLoader.stopWithError(error)
            }
        },

        getLocation: async function() {
             try {
                const location = await LocationService.getLocation(this.$route.params.id)
                this.handleLocationResponse(location)
            } catch (error) {
                this.screenLoader.stopWithError(error)
            }
        },

        createLocation: async function() {
            // TODO: When POST and PUT are available
        },

        updateLocation: async function(location) {
            try {
                let response = await LocationService.putLocation(location)
                this.handleMutateLocationResponse(response, "The location has successfully been updated")
            } catch (error) {
                console.log(error)
                this.handleMutateLocationFailureResponse(error.errorCode, error.message)
            }
        },

        updateEntities: async function(exceptionsOnly = false) {
            const groups = await GroupService.getGroups()
            const entities = this.location.groups.flatMap(g => g.entities)

            for (let e of entities) {
                let group = groups.filter(g => g.entities.map(ent => ent.id).includes(e.id))[0]
                let entity = await EntityService.getEntityById(e.id)
                if (!exceptionsOnly) {
                    entity.openingHours = this.location.openingHours
                    // also set the start and end date
                    entity.timeSlotStartTime = this.location.timeSlotStartTime
                    entity.timeSlotEndTime = this.location.timeSlotEndTime
                } else {
                    // only modify the exceptions
                    const openingHours = entity.openingHours
                    openingHours.exceptions = this.location.openingHours.exceptions
                    entity.openingHours = openingHours
                }

                try {
                    await  EntityService.putEntity(entity, group.id)
                } catch (error) {
                    console.log(error)
                    await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.code, message: "entity update failed" })
                }
            }
        },

        handleMetaDataResponse(groups) {
            this.groups = groups.map(o => new Group(o))
            this.dropdownGroups = groups.map(o => new GroupDropdown(o))

            if (this.$route.params.id != 'new') {
                this.getLocation()
            }else{
                this.screenLoader.stop(['locations'])
            }
        },

        handleLocationResponse(location) {
            this.location = new Location(location)
            this.alertOnGateUpdate = location.alertOnGateUpdate
            this.bookingsPrivateForAgent = location.bookingsPrivateForAgent
            this.screenLoader.stop(['locations'])
        },

        handleMutateLocationResponse(response, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: message })
            router.push(`/settings/locations/`)
        },
        handleMutateLocationFailureResponse(code, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: code, message: message.errorAtEntry })
        },

        addGroup(id) {
            const group = this.location.groups.filter(group => group.id == id)
            if (group.length == 0) {
                this.location.groups.push(this.groups.filter(group => group.id == id)[0])
            }
        },

        removeGroup(id) {
            // TODO:  When POST and PUT are available
            // this.location.groups = this.location.groups.filter(group => group.id != id)
        },

        toggleExceptionOnly () {
            this.exceptionOnly = !this.exceptionOnly
        },

        toggleAlertOnGateUpdate() {
            this.alertOnGateUpdate = !this.alertOnGateUpdate
            this.location.alertOnGateUpdate = this.alertOnGateUpdate
        },

        toggleBookingsPrivate () {
            this.bookingsPrivateForAgent = !this.bookingsPrivateForAgent
            this.location.bookingsPrivateForAgent = this.bookingsPrivateForAgent
        }
    }
}
